import config from 'config';
import { ListPayload, ListResponse, SuccessResponse } from 'core/http/response';
import axiosClient from 'config/axios';
import { CommodityCondition, CommodityConditionRequest, ListCommodityConditionParams } from './commodityCondition';

const COMMODITY_CONDITIONS_URL = `${config.declarationsUrl}/ireland/ais/commodity-condition-mappings`;

// PUT and DELETE need the latest quoted version: missing gives 428, stale gives 412
const ifMatch = (version: number) => ({ headers: { 'If-Match': `"${version}"` } });

export const listCommodityConditions = (
    params: ListCommodityConditionParams
): Promise<ListPayload<CommodityCondition>> =>
    axiosClient
        .get<ListResponse<CommodityCondition>>(COMMODITY_CONDITIONS_URL, { params })
        .then((response) => response.data.payload);

export const getCommodityCondition = (conditionId: string): Promise<CommodityCondition> =>
    axiosClient
        .get<SuccessResponse<CommodityCondition>>(`${COMMODITY_CONDITIONS_URL}/${conditionId}`)
        .then((response) => response.data.payload);

export const createCommodityCondition = (condition: CommodityConditionRequest): Promise<CommodityCondition> =>
    axiosClient
        .post<SuccessResponse<CommodityCondition>>(COMMODITY_CONDITIONS_URL, condition)
        .then((response) => response.data.payload);

export const updateCommodityCondition = (
    conditionId: string,
    version: number,
    condition: CommodityConditionRequest
): Promise<CommodityCondition> =>
    axiosClient
        .put<SuccessResponse<CommodityCondition>>(
            `${COMMODITY_CONDITIONS_URL}/${conditionId}`,
            condition,
            ifMatch(version)
        )
        .then((response) => response.data.payload);

export const deleteCommodityCondition = (conditionId: string, version: number): Promise<void> =>
    axiosClient
        .delete<SuccessResponse<void>>(`${COMMODITY_CONDITIONS_URL}/${conditionId}`, ifMatch(version))
        .then(() => undefined);
